exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.schedule > li[data-v-6ab6fa62] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #DBDFE2;\n}\n.schedule > li[data-v-6ab6fa62]:first-child {\n    border: 0;\n}\n.add[data-v-6ab6fa62] {\n  margin-bottom: 3.5rem;\n}\n.form-error-msg[data-v-6ab6fa62] {\n  margin-bottom: -1.565rem;\n}\n.input-min-height[data-v-6ab6fa62] {\n  min-height: 5.07rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6ab6fa62","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/people/agents/AgentForm.vue
// module id = 1193
// module chunks = 0